export const checkDataIntegrity = (): boolean => {
  try {
    const items = [
      "authUser",
      "language",
      "pwa-installed",
      "seenMacLinuxWarning",
    ];

    items.forEach(key => {
      const value = localStorage.getItem(key);
      if (value) {
        if (key === "authUser" || key === "language") {
          try {
            JSON.parse(value);
          } catch (e) {
            localStorage.removeItem(key);
          }
        }
      }
    });

    const sessionItems = ["session-data", "temp-auth"];

    sessionItems.forEach(key => {
      const value = sessionStorage.getItem(key);
      if (value) {
        try {
          JSON.parse(value);
        } catch (e) {
          sessionStorage.removeItem(key);
        }
      }
    });

    return true;
  } catch (error) {
    return false;
  }
};

export const clearCorruptedData = (): void => {
  const keysToCheck = ["authUser", "language"];

  keysToCheck.forEach(key => {
    const value = localStorage.getItem(key);
    if (value) {
      try {
        const parsed = JSON.parse(value);
        if (
          !parsed ||
          (typeof parsed !== "object" && typeof parsed !== "string")
        ) {
          localStorage.removeItem(key);
        }
      } catch (e) {
        localStorage.removeItem(key);
      }
    }
  });
};

export const initializeDataIntegrity = (): void => {
  if (process.env.NODE_ENV === "development") {
    window.addEventListener("beforeunload", () => {
      clearCorruptedData();
    });
  }

  checkDataIntegrity();
};
